import { ref } from 'vue'

export function usePrintSettings() {
  // Paper format settings
  const paperFormat = ref('A4')
  const paperFormats = [
    { title: 'A4', value: 'A4' },
    { title: 'Letter', value: 'Letter' },
    { title: 'Legal', value: 'Legal' }
  ]
  
  // Layout settings
  const columnCount = ref(4)
  const controlsExpanded = ref(false)
  
  // Display options
  const showImages = ref(true)
  const showTitle = ref(true)
  const showDescription = ref(true)
  const showCheckedItems = ref(true)
  const showMetadata = ref(false)
  const showHeaderImage = ref(true)
  const headerImageOpacity = ref(50)
  
  // Export state
  const exportingPDF = ref(false)
  
  return {
    // Paper format
    paperFormat,
    paperFormats,
    
    // Layout
    columnCount,
    controlsExpanded,
    
    // Display options
    showImages,
    showTitle,
    showDescription,
    showCheckedItems,
    showMetadata,
    showHeaderImage,
    headerImageOpacity,
    
    // Export state
    exportingPDF
  }
}